import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, EmailStatusBanner } from "@/components/admin/PageHeader";
import { Loader2, Mail } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { formatDateTime } from "@/lib/format";

const LABELS = {
  admin_enquiry_notification: "Admin enquiry notification",
  visitor_acknowledgement: "Visitor acknowledgement",
  agency_referral: "Agency referral",
  contact_notification: "Contact notification",
  partnership_request: "Partnership request",
  password_reset: "Password reset",
};

export default function EmailPreview() {
  const [data, setData] = useState(null);
  const [view, setView] = useState(null);
  useEffect(() => { api.get("/admin/emails").then((r) => setData(r.data)).catch(() => setData({ logs: [], email_configured: false })); }, []);

  if (!data) return <div className="flex justify-center py-24"><Loader2 className="w-8 h-8 text-[#C81D35] animate-spin" /></div>;

  return (
    <div>
      <PageHeader title="Email preview & logs" subtitle="Every generated email is logged here" />
      <EmailStatusBanner configured={data.email_configured} />
      <div className="bg-white rounded-xl border border-border overflow-hidden">
        {data.logs.length === 0 ? <div className="text-center py-16 text-muted-foreground" data-testid="emails-empty">No emails generated yet.</div>
          : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-muted-foreground border-b border-border"><th className="p-4 font-medium">Type</th><th className="p-4 font-medium">Subject</th><th className="p-4 font-medium">To</th><th className="p-4 font-medium">Status</th><th className="p-4 font-medium">Generated</th><th className="p-4"></th></tr></thead>
            <tbody>
              {data.logs.map((l) => (
                <tr key={l.id} className="border-b border-border/60 last:border-0 hover:bg-muted/30" data-testid={`email-row-${l.id}`}>
                  <td className="p-4 text-[#111827]">{LABELS[l.type] || l.type}</td>
                  <td className="p-4 text-muted-foreground">{l.subject}</td>
                  <td className="p-4 text-muted-foreground">{l.to || "—"}</td>
                  <td className="p-4"><span className={`text-xs px-2 py-1 rounded-full ${l.status === "sent" ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>{l.status_label}</span></td>
                  <td className="p-4 text-muted-foreground whitespace-nowrap">{formatDateTime(l.created_at)}</td>
                  <td className="p-4"><Button variant="ghost" size="sm" onClick={() => setView(l)} data-testid={`view-email-${l.id}`} className="gap-1.5"><Mail className="w-4 h-4" /> Preview</Button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <Dialog open={!!view} onOpenChange={(o) => !o && setView(null)}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader><DialogTitle>{view?.subject}</DialogTitle></DialogHeader>
          <p className="text-xs text-muted-foreground">To: {view?.to || "—"} · {view?.status_label}</p>
          <div className="border border-border rounded-lg overflow-hidden mt-2" dangerouslySetInnerHTML={{ __html: view?.html }} />
        </DialogContent>
      </Dialog>
    </div>
  );
}
